import { BaseSavedSearch, HolidayRentalSavedSearchDto } from "../model/model";
import { RestClient } from "./RestClient";
import { SavedSearchClient } from "../model/SavedSearchClient";
import { HolidayRentalMapper } from "../mappers/HolidayRentalMapper";

export class HolidayRentalSavedSearchClient implements SavedSearchClient {
  private client: RestClient<HolidayRentalSavedSearchDto>;

  constructor() {
    this.client = new RestClient("/api/holiday-rental-saved-search");
  }

  async getAll(): Promise<BaseSavedSearch[]> {
    const data: HolidayRentalSavedSearchDto[] = await this.client.get("/");
    return data.map((d) => HolidayRentalMapper.dtoToModel(d));
  }

  async get(searchId: number): Promise<BaseSavedSearch> {
    const data: HolidayRentalSavedSearchDto = await this.client.get(
      `/${searchId}`
    );
    return HolidayRentalMapper.dtoToModel(data);
  }

  async update(search: BaseSavedSearch): Promise<void> {
    const updatedSavedSearch: HolidayRentalSavedSearchDto =
      HolidayRentalMapper.modelToDto(search);

    await this.client.put(`/${updatedSavedSearch.id}`, updatedSavedSearch);
  }

  async delete(searchId: number): Promise<void> {
    await this.client.delete(`/${searchId}`);
  }

  // eslint-disable-next-line class-methods-use-this
  async create(): Promise<number> {
    throw new Error("HolidayRental Saved Search creation not supported.");
  }
}
